module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai375-382fc412e94c2f2116913ed1d53f2147.jpg";